import fillProductKey from './middlewares/fillProductKey'
import populate from './middlewares/populate'
import productsB from './ui/productsB'

module.exports = {
  model: 'products',
  name: 'B-鏡片資料',
  ui: productsB,
  middlewares: [populate, fillProductKey],
}



// WEBPACK FOOTER //
// ./src/views/productsB.js